<script lang="ts">
	interface Props {
		state: {
			items: unknown[];
			total: number;
			nextCursor?: string;
			loading: boolean;
			error: string | null;
		};
		onloadmore: () => void;
		onretry: () => void;
	}
	let { state, onloadmore, onretry }: Props = $props();
</script>

{#if state.items.length > 0}
	<div class="admin-list-footer" aria-live="polite">
		<span>Показано {state.items.length} из {state.total}</span>
		{#if state.error}
			<strong>{state.error}</strong><button type="button" disabled={state.loading} onclick={onretry}
				>Повторить</button
			>
		{:else if state.nextCursor}
			<button type="button" disabled={state.loading} onclick={onloadmore}
				>{state.loading ? 'Загружаем…' : 'Загрузить ещё'}</button
			>
		{/if}
	</div>
{/if}

<style>
	.admin-list-footer {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		gap: var(--spacing-m);
		padding: var(--spacing-l);
		color: var(--text-secondary);
		font-size: var(--font-size-s);
	}
	strong {
		color: var(--status-danger);
	}
	button {
		min-height: var(--admin-touch-target);
		padding: var(--spacing-s) var(--spacing-l);
		border: var(--size-1) solid var(--border-subtle);
		border-radius: var(--radius-s);
		background: var(--background-secondary);
		color: var(--text-primary);
		font: inherit;
		cursor: pointer;
	}
	button:disabled {
		opacity: 0.55;
		cursor: wait;
	}
	button:focus-visible {
		outline: var(--size-2) solid var(--accent-primary);
		outline-offset: var(--size-2);
	}
</style>
